import { render, staticRenderFns } from "./sender-email-addresses-tab.vue?vue&type=template&id=6733c3e9"
import script from "./sender-email-addresses-tab.vue?vue&type=script&lang=js"
export * from "./sender-email-addresses-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports